import DataTable from "../../components/ui/DataTable";
import Button from "../../components/ui/Button";

const columns = [
  { accessorKey: "name", header: "Naam", meta: { width: "32%" } },
  {
    accessorKey: "email",
    header: "E-mail",
    meta: { width: "28%" },
  },
  {
    accessorKey: "organization",
    header: "Organisatie",
    meta: { width: "25%" },
    cell: (info) => info.getValue() || "—",
  },
  {
    accessorKey: "role",
    header: "Rol",
    meta: { width: "15%" },
    cell: (info) => (info.getValue() === "admin" ? "Administrator" : "Gebruiker"),
  },
];

export default function GebruikersTable({
  title,
  description,
  emptyMessage,
  users,
  isLoading,
  onAddUser,
  onEditUser,
  addLabel = "Voeg gebruiker toe",
  countLabel,
}) {
  const resolvedDescription = isLoading && users.length === 0
    ? "Gegevens worden geladen…"
    : users.length > 0
      ? description
      : emptyMessage;

  return (
    <DataTable
      title={title}
      label={countLabel || `${users.length} gebruikers`}
      description={resolvedDescription}
      data={users}
      columns={columns}
      headerActions={
        <>
          <Button
            variant="secondary"
            icon="/icons/download-cloud-02.png"
            iconPosition="left"
          >
            Download CSV
          </Button>
          <Button
            variant="primary"
            icon="/icons/plus.png"
            iconPosition="left"
            onClick={onAddUser}
          >
            {addLabel}
          </Button>
        </>
      }
      rowActions={(row) => (
        <div className="row-actions">
          <button type="button" onClick={() => onEditUser?.(row)}>
            <img src="/icons/pencil.png" alt="Bewerken" />
          </button>
        </div>
      )}
    />
  );
}
